import { useState, useEffect } from 'react';
import { Link, useLocation } from 'wouter';
import { Menu, X, Download } from 'lucide-react';
import RambaLogo from './RambaLogo';

const navItems = [
  { href: '/', label: 'الرئيسية' },
  { href: '/shops', label: 'المغاسل' },
  { href: '/terms', label: 'الشروط' },
  { href: '/privacy', label: 'الخصوصية' },
];

export default function Header() {
  const [location] = useLocation();
  const [menuOpen, setMenuOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  return (
    <header
      className={`sticky top-0 z-50 transition-all duration-500 border-b ${
        scrolled
          ? 'bg-white/90 backdrop-blur-sm border-gray-200 shadow-sm'
          : 'bg-white/90 backdrop-blur-sm border-gray-100'
      }`}
    >
      <div className="max-w-5xl mx-auto px-4">
        <div className="flex items-center justify-between h-16">
          {/* Logo */}
          <Link href="/" className="flex items-center gap-1.5">
            <RambaLogo className="w-10 h-10 rounded-[3px]" />
            <span className="text-xl font-bold text-text-brand">رمبا</span>
          </Link>

          {/* Desktop Nav */}
          <nav className="hidden md:flex items-center gap-1">
            {navItems.map((item) => (
              <Link
                key={item.href}
                href={item.href}
                className={`text-base font-medium px-3 py-1.5 rounded-lg transition-colors ${
                  location === item.href
                    ? 'text-primary-600 bg-primary-50'
                    : 'text-text-muted hover:text-text-brand hover:bg-gray-50'
                }`}
              >
                {item.label}
              </Link>
            ))}
          </nav>

          {/* Desktop CTA */}
          <a
            href="#download"
            className="hidden md:flex items-center gap-2 bg-primary-600 hover:bg-primary-500 text-white text-base font-medium px-4 py-2 rounded-full transition-colors"
          >
            <Download className="w-4 h-4" />
            حمّل التطبيق
          </a>

          {/* Mobile Toggle */}
          <button
            className="md:hidden p-2 rounded-lg text-text-muted hover:text-text-brand hover:bg-gray-50 transition-colors"
            onClick={() => setMenuOpen(!menuOpen)}
          >
            {menuOpen ? <X className="w-5 h-5" /> : <Menu className="w-5 h-5" />}
          </button>
        </div>

        {/* Mobile Nav */}
        {menuOpen && (
          <div className="md:hidden pb-4 border-t border-gray-100 pt-3">
            <nav className="flex flex-col gap-1">
              {navItems.map((item) => (
                <Link
                  key={item.href}
                  href={item.href}
                  onClick={() => setMenuOpen(false)}
                  className={`px-3 py-2.5 rounded-lg text-sm font-medium transition-colors ${
                    location === item.href
                      ? 'bg-primary-50 text-primary-600'
                      : 'text-text-muted hover:bg-gray-50 hover:text-text-brand'
                  }`}
                >
                  {item.label}
                </Link>
              ))}
              <a
                href="#download"
                onClick={() => setMenuOpen(false)}
                className="flex items-center gap-2 bg-primary-600 text-white text-sm font-medium px-3 py-2.5 rounded-lg mt-2 transition-colors hover:bg-primary-500"
              >
                <Download className="w-4 h-4" />
                حمّل التطبيق
              </a>
            </nav>
          </div>
        )}
      </div>
    </header>
  );
}
